import React, { useContext, useState } from "react";
import { UserContext } from "../context/UserContext";
import DesktopNavigation from "../components/navigation/DesktopNavigation";
import MobileNavigation from "../components/navigation/MobileNavigation";
import AuthModals from "../components/auth/AuthModals";
import { Link } from "react-router-dom";
import { logout as logoutAPI } from "../services/AuthAPI";
import { Messages } from "../constants/Messages";
import Footer from "../components/generic/Footer";

interface BaseLayoutProps {
    children: React.ReactNode;
    header?: string;
}

const BaseLayout: React.FC<BaseLayoutProps> = ({ children, header }) => {
    const [ showLogin, setShowLogin ] = useState(false);
    const [ isMenuOpen, setIsMenuOpen ] = useState(false);
    const { setIsLoggedIn, logout } = useContext(UserContext);

    const handleLogout = async () => {
        try {
            await logoutAPI();
            logout();
            setIsLoggedIn(false);
            window.location.reload(); // Reload to clear sensitive data, if necessary
        } catch (error) {
            console.error(Messages.ERROR_LOGOUT);
        }
    };

    const transitionClass = "transition duration-300";

    return (
        <div className={`min-h-screen bg-white dark:bg-gray-800`}>
            {/* Header Navigation */}
            <nav
                className="shadow-md sticky top-0 z-50 flex justify-between items-center px-6 py-4 lg:hidden bg-gray-50 dark:bg-gray-900">
                <h1 className="text-2xl font-extrabold">
                    <Link
                        to="/"
                        className={`hover:text-blue-500 dark:hover:text-blue-300 ${transitionClass}`}
                    >
                        Material Logs
                    </Link>
                </h1>
                <a
                    className="nav-toggle"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    aria-label="Toggle navigation menu"
                >
                    <span className={`${transitionClass}`}/>
                    <span className={`my-1 ${transitionClass}`}/>
                    <span className={`${transitionClass}`}/>
                </a>
            </nav>

            {/* Desktop Navigation */}
            <DesktopNavigation
                handleLogout={handleLogout}
                showLogin={() => setShowLogin(true)}
            />

            {/* Mobile Navigation */}
            <MobileNavigation
                isMenuOpen={isMenuOpen}
                setIsMenuOpen={setIsMenuOpen}
                handleLogout={handleLogout}
                showLogin={() => setShowLogin(true)}
            />

            {/* Main Content */}
            <main className="p-2 sm:px-10 sm:py-6 lg:pl-8">
                {children}
            </main>
            {/* Authentication Modals */}
            <AuthModals showLogin={showLogin} setShowLogin={setShowLogin}/>

            <Footer/>
        </div>
    );
};

export default BaseLayout;